import './BaseAppLogo.scss'

export default abstract class BaseAppLogo extends HTMLElement {
  protected abstract get text (): string

  public connectedCallback (): void {
    this.classList.add('sni-app-logo')

    this.appendChild(this.render())
  }

  /** HTML strukctúra visszaadása. */
  protected render (): HTMLElement {
    return (
      <div id="title-container" className="sni-app-logo__title-container">
        <div className="sni-app-logo__stroke">{ this.text }</div>
        <div className="sni-app-logo__content">{ this.text }</div>
      </div>
    )
  }
}
